import React from 'react';
import { Button } from '../../../components/ui/button';
import { Badge } from '../../../components/ui/badge';
import { CheckCircle2, MessageCircle, Phone, Mail } from 'lucide-react';
import { fmtDate, fmtTimeAgo, whatsappLink } from './utils';

export const AbandonedCartItem = ({ cart, onMarkContacted }) => {
  const wa = whatsappLink(cart);
  const items = cart.items || [];
  const itemCount = items.length;
  const mailto = cart.email
    ? `mailto:${cart.email}?subject=Complete your Sanatanbhavan order&body=Hi ${cart.name || 'there'},%0D%0A%0D%0AYou left items worth ₹${cart.total} in your cart. Complete your order here: https://sanatanbhavan.com/cart`
    : null;

  return (
    <div
      data-testid={`abandoned-cart-${cart.id}`}
      className={`border-t p-4 hover:bg-orange-50/40 ${cart.contacted ? 'opacity-60' : ''}`}
    >
      <div className="flex flex-wrap items-start justify-between gap-3">
        <div className="flex-1 min-w-[200px]">
          <div className="flex items-center gap-2 flex-wrap">
            <span className="font-semibold text-gray-800">
              {cart.name || (cart.user_id ? 'Customer' : 'Anonymous Visitor')}
            </span>
            {cart.user_id ? (
              <Badge variant="secondary" className="text-xs">Registered</Badge>
            ) : (
              <Badge variant="outline" className="text-xs">Guest</Badge>
            )}
            {cart.contacted && <Badge className="bg-green-600 text-xs">Contacted</Badge>}
          </div>
          <div className="text-xs text-gray-500 mt-1 space-y-0.5">
            {cart.email && <div className="flex items-center gap-1"><Mail size={12} /> {cart.email}</div>}
            {cart.phone && <div className="flex items-center gap-1"><Phone size={12} /> {cart.phone}</div>}
            <div>Last activity: {fmtTimeAgo(cart.last_activity_at)} ({fmtDate(cart.last_activity_at)})</div>
            <div className="font-mono text-[10px] opacity-60">SID: {cart.session_id.slice(0, 16)}...</div>
          </div>
        </div>
        <div className="text-right">
          <p className="text-2xl font-bold text-orange-700">₹{cart.total.toLocaleString('en-IN')}</p>
          <p className="text-xs text-gray-500">{itemCount} item{itemCount !== 1 ? 's' : ''}</p>
        </div>
      </div>

      <div className="mt-3 flex flex-wrap gap-2">
        {items.map((it, idx) => (
          <div key={idx} className="flex items-center gap-2 bg-gray-50 border rounded-md pl-1 pr-3 py-1 text-sm">
            {it.product_image && (
              <img src={it.product_image} alt="" className="w-8 h-8 rounded object-cover" />
            )}
            <span className="truncate max-w-[160px]">{it.product_name}</span>
            <span className="text-xs text-gray-500">x{it.quantity}</span>
            <span className="font-medium">₹{it.price * it.quantity}</span>
          </div>
        ))}
      </div>

      <div className="mt-3 flex flex-wrap gap-2">
        {wa && (
          <a href={wa} target="_blank" rel="noreferrer" data-testid={`whatsapp-${cart.id}`}>
            <Button size="sm" className="bg-green-600 hover:bg-green-700">
              <MessageCircle size={14} className="mr-1" /> WhatsApp Reminder
            </Button>
          </a>
        )}
        {mailto && (
          <a href={mailto} data-testid={`email-${cart.id}`}>
            <Button size="sm" variant="outline">
              <Mail size={14} className="mr-1" /> Send Email
            </Button>
          </a>
        )}
        {!cart.contacted && (
          <Button
            size="sm"
            variant="ghost"
            onClick={() => onMarkContacted(cart.id)}
            data-testid={`mark-contacted-${cart.id}`}
          >
            <CheckCircle2 size={14} className="mr-1" /> Mark Contacted
          </Button>
        )}
      </div>
    </div>
  );
};
